export const serviceCategoriesTranslations = {
    services_categories: {
        comprehensiveTesting: {
            id: "comprehensive-testing",
            title: "خدمات اختبار شاملة",
            subtitle: "برمجياتك تستحق الكمال، دعنا نضمن ذلك! ✅",
            description: "تقدم خدماتنا الشاملة للاختبار وظائف خالية من العيوب، أداء متميز، وتجارب مستخدم استثنائية. باستخدام أحدث الأدوات، منهجيات مدعومة بالذكاء الاصطناعي، وفريق من محترفي ضمان الجودة ذوي الخبرة، نقدم حلول اختبار تضمن أن برمجياتك تلبي أعلى المعايير في كل إصدار.",
        },
        coachingServices: {
            id: "mentoring-coaching",
            title: "التوجيه والتدريب",
            subtitle: "تمكين فريقك من خلال التوجيه الخبير ونقل المعرفة 🎓",
            description: "تساعد خدمات التوجيه والتدريب لدينا في بناء قدرات ضمان الجودة الداخلية داخل مؤسستك. نقدم توجيهًا مخصصًا، وتنفيذ أفضل الممارسات، واستشارات استراتيجية لرفع مستوى خبرة فريقك في الاختبارات.",
        },
        crowdTesting: {
            id: "crowd-testing",
            title: "خدمات الاختبار الجماعي",
            subtitle: "استفد من قوة مجتمع الاختبار العالمي 🌍",
            description: "تستفيد خدمات الاختبار الجماعي لدينا من الخبرة الجماعية لمجتمع الاختبار العالمي لتقديم وجهات نظر متنوعة، سيناريوهات اختبار واقعية، وتغطية شاملة عبر أجهزة ومنصات وسلوكيات مستخدم مختلفة.",
        }
    }
}